import React, { useRef, useEffect } from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { GreenroomState as GS } from '../../../stores/types/types';
import Icon, { ICONS, COLORS } from '../icon';

const audioTest = require('../../../audio/brandlive.mp3');

interface ChromiumHTMLMediaElement extends HTMLMediaElement {
    setSinkId(sinkId: string): Promise<void>;
}

enum SoundTestStyle {
	DeviceTab = 0,
	Onboarding = 1,
}

interface Props {
	style: SoundTestStyle;
}

export default function SoundTestWidget() {
	const audioOutputs = useSelector((s: GS) => s.VideoReducer.audioOutputs);
	const selectedOutput = useSelector((s: GS) => s.VideoReducer.selectedOutput);
	const audioEl = useRef<ChromiumHTMLMediaElement | null>(null);

    useEffect(() => {
        if (selectedOutput?.deviceId && audioEl.current) {
            audioEl.current.setSinkId(selectedOutput.deviceId).catch((err: any) => {
                console.error(err);
            });
        }
    }, [selectedOutput]);

	function testAudio() {
		audioEl.current?.play();
	}

	return (<>
		<div className={classNames('option-row-buttons', audioOutputs.length === 0 && 'disabled')}>
			<button className="xsmall" onClick={testAudio} style={{ display: 'flex', backgroundColor: 'rgba(0,0,0,0)' }}>
				<Icon name={ICONS.SOUND} size={16} color={COLORS.WHITE}></Icon>
				<span style={{
					marginLeft: '7px',
					fontSize: '11px',
					fontWeight: '600',
					lineHeight: '16px',
					letterSpacing: '0.02em',
					textAlign: 'left',
					color: 'white',
				}}>Test</span>
			</button>
		</div> 
		<audio ref={audioEl} src={audioTest}></audio>
	</>);
}
